<template>
    <div 
        v-if="data.length"
        class="page-wrapper"
        :style="{
            transition:'all 0.5s ease-in',
            backgroundRepeat:'no-repeat',
            backgroundImage:`url(${sourceMaps[(data[middleIndex] || {}).contentId] })`,
            // backgroundImage:`url(${ getFullPathMethod( ( data[middleIndex] || {}  ).backgroundImagePath ) })`,
            backgroundSize:'cover'
        }"
    >
        <div class="page-content">
            <div class="follow-container">
                <!-- <el-button @click="handleToggle" style="position:absolute; left:100px; top:100px; z-index:10; ">change</el-button> -->
                <div class="follow-top">
                    <div class="slider-container" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                        <div class="slider-wrapper">
                            <div
                                v-for="(item, index) in data"
                                :key="item.contentId"
                                class="slider-item"
                                :style="{
                                    transform:`translateX(${ ( index - middleIndex ) * 100 }%) scale(${ index === middleIndex ? 1.3 :1 })`,
                                    opacity:`${ 1 - ( Math.abs(index - middleIndex) / 10 ) * 2  }`
                                }"
                            >
                                <img 
                                    :src="getFullPathMethod(item.iconPath)" 
                                    style="cursor:pointer;"
                                    @click="e=>handleMove(e, item.tittle)" 
                                />
                            </div>
                            
                        </div>
                        <Transition name="fade">
                            <div class="slider-text" :key="( data[middleIndex] || {} ).tittle">{{ ( data[middleIndex] || {} ).tittle }}</div>
                        </Transition>
                    </div>
                </div>
                <div class="follow-bottom">
                    <div class="content-wrapper">
                        <div ref="prevRef" class="content-bg prev" :style="{ backgroundImage:`url(${ getFullPathMethod(prevItem.interfacePath) })` }" ></div> 
                        <div ref="nextRef" class="content-bg next" :style="{ backgroundImage:`url(${ getFullPathMethod( ( data[middleIndex] || {} ).interfacePath ) })`}"></div>  
                        <div class="content-bg-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getFullPath, getContentList } from '@/api/global.js';
   
    export default {
        data(){
            return {
                data:[],
                prevItem:{},
                timer:null,
                contentTimer:null,
                middleIndex:0,
                sourceMaps:{}
            }
        },
        methods:{
            getFullPathMethod(url){
                return getFullPath(url);
            },
            getImage(id, path){
                return new Promise((resolve, reject)=>{
                    if ( this.sourceMaps[id] ) {
                        resolve();
                        return;
                    }
                    fetch(getFullPath(path))
                    .then(res=>res.blob())
                    .then(blob=>{
                        let reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onload = (e)=>{
                            this.sourceMaps[id] = e.target.result;
                            resolve();
                        }
                    })
                })
            },
            handleToggle(){
                clearTimeout(this.contentTimer);
                let arr = [...this.data];
                let firstEle = null;
                for(let i = 0; i < arr.length; i++){
                    if ( i === 0 ) {
                        firstEle = arr[0];
                    }
                    if ( i === arr.length - 1 ) {
                        arr[i] = firstEle;
                    } else {
                        arr[i] = arr[i+1];
                    }
                }
                // 加载中间索引值下一个索引的图片资源
                this.getImage(arr[this.middleIndex+1].contentId, arr[this.middleIndex+1].backgroundImagePath);
                // 更新底部跟随变化的内容区
                this.data = arr;
                this.$refs.prevRef.classList.add('active');
                this.$refs.nextRef.classList.add('active');        
                this.contentTimer = setTimeout(()=>{
                    this.prevItem = this.data[this.middleIndex];        
                    this.$refs.prevRef.classList.remove('active');
                    this.$refs.nextRef.classList.remove('active');
                }, 700);
            },
            fetchContentList(){
                getContentList({ page:1, pageSize:20, contentType:'首页产品轮播' })
                .then(res=>{
                    if ( res.data.code === 200 ) {
                        // 提前加载缓存所有图片资源      
                        if ( res.data.data && res.data.data.length ) {
                            let middleIndex = Math.floor(res.data.data.length / 2);
                            let firstEle = res.data.data.filter((item, i)=>i === middleIndex )[0];
                            let secondEle = res.data.data.filter((item, i)=> i === middleIndex + 1 )[0];
                            this.middleIndex = middleIndex;
                            // 先加载中间项和中间项的后一项
                            if ( secondEle ) {
                                this.getImage(secondEle.contentId, secondEle.backgroundImagePath);
                            }
                            this.getImage(firstEle.contentId, firstEle.backgroundImagePath).then(()=>{
                                this.data = res.data.data;   
                                this.prevItem = res.data.data[this.middleIndex];
                                this.timer = setInterval(()=>{
                                    this.handleToggle();
                                }, 4000)
                            })  
                        }
                    }
                })
            },
            handleMove(e, tittle){
                let newIndex = 0;
                for ( let i = 0; i < this.data.length; i++){
                    if ( tittle === this.data[i].tittle ) {
                        newIndex = i;
                    }
                }
                let offset = newIndex - this.middleIndex;

                // console.log(newIndex);
                let newArr = [ ...this.data ];
                //  1 2 3 4 5 6    0 1 2 3 4 5
                //  3 4 5 6 1 2    2 3 4 5 0 1
                for ( let i = 0; i < newArr.length; i++ ) {
                    // 根据offset正负判断偏移方向
                    if ( offset < 0 ) {
                        newArr[i].nextIndex = i + Math.abs(offset) >= newArr.length ? (i + Math.abs(offset)) % newArr.length  : i + Math.abs(offset);
                    } else {
                        newArr[i].nextIndex = i - offset < 0 ? newArr.length - Math.abs(i - offset) : i - offset;    
                    }
                }
                // console.log(newArr);
                // 根据nextIndex重新排序
                newArr.sort((a,b)=> a.nextIndex < b.nextIndex ? -1 : 1 );
                // 加载当前索引值的背景图资源
                this.getImage(newArr[this.middleIndex].contentId, newArr[this.middleIndex].backgroundImagePath)
                .then(()=>{
                    this.data = newArr;
                    this.$refs.prevRef.classList.add('active');
                    this.$refs.nextRef.classList.add('active');        
                    this.contentTimer = setTimeout(()=>{
                        this.prevItem = this.data[this.middleIndex];        
                        this.$refs.prevRef.classList.remove('active');
                        this.$refs.nextRef.classList.remove('active');
                    }, 700);
                })
            },
            handleMouseEnter(){
                clearInterval(this.timer);
            },
            handleMouseLeave(){
                this.timer = setInterval(()=>{
                    this.handleToggle();
                }, 4000)
            }
        },
        mounted(){
            this.fetchContentList();
        },
        beforeDestroy(){
            clearInterval(this.timer);
            clearTimeout(this.contentTimer);
            
        }
    }
  
</script>
<style scoped>
    @import './style.css';
</style>

